<template>
	<div class="step">
		<div class="container">
			<div class="row">
				<div class="col-lg-2"></div>
				<div class="col-lg-8 col-md-12 col-sm-12 col-12">
					<div class="step-line flex">
						<div class="step-line-ever text-center line-click">选择商品</div>
						<i class="el-icon-d-arrow-right line-click" style="padding-top: 13px"></i>
						<div class="step-line-ever text-center line-click">填写订单</div>
						<i class="el-icon-d-arrow-right line-click" style="padding-top: 13px"></i>
						<div class="step-line-ever text-center line-click">在线支付</div>
						<i class="el-icon-d-arrow-right line-click" style="padding-top: 13px"></i>
						<div class="step-line-ever text-center line-click">支付成功</div>
					</div>
					<div class="payok-pc flex justify-content-space-between">
						<div class="payok-left flex-column justify-content-center align-items">
							<img src="@/assets/payok.png" alt="" style="width:57px;height:57px;">
							<p style="font-size:24px;color:#ffffff;margin-top:15px;">支付成功！</p>
							<p style="font-size:22px;color:#ffffff;margin-top:15px;">￥{{payOkData.totalMoney}}</p>
						</div>
						<div class="payok-right flex-column">
							<div class="payok-ordercode flex color-999">订单编号：
								<div class="color-666" style="margin-left:5px;">{{payOkData.orderno}}</div>
							</div>
							<div class="payok-oderinfo flex color-999">收货信息：
								<div style="margin-left:5px;">
									<div class="color-666">{{payOkData.name}} {{payOkData.phone}}</div>
									<div class="color-666">{{payOkData.province}} {{payOkData.city}} {{payOkData.area}} {{payOkData.address}}</div>
								</div>
							</div>
							<div @click="touser" class="payok-right-btn page-click flex justify-content-space-around align-items">查看订单详情</div>
						</div>
					</div>
					<div class="payok-mob">
						<div class="payok-top flex-column justify-content-center align-items">
							<img src="@/assets/payok.png" alt="" style="width:32px;height:32px;">
							<p style="font-size:18px;color:#ffffff;margin-top:15px;">支付成功！</p>
							<p style="font-size:18px;color:#ffffff;margin-top:15px;">￥{{payOkData.totalMoney}}</p>
						</div>
						<div class="payok-bottom">
							<div class="payok-ordercode flex color-999" style="margin-left:25px;padding-top:20px;">订单编号：
								<div class="color-666" style="margin-left:5px;">{{payOkData.orderno}}</div>
							</div>
							<div class="payok-oderinfo flex color-999" style="margin-left:25px;">收货信息：
								<div style="margin-left:5px;">
									<div class="color-666">{{payOkData.name}} {{payOkData.phone}}</div>
									<div class="color-666">{{payOkData.province}} {{payOkData.city}} {{payOkData.area}} {{payOkData.address}}</div>
								</div>
							</div>
							<div style="width:100%;margin-top:30px;" class="flex justify-content-space-around">
								<div @click="touser" class="payok-right-btn2 page-click flex justify-content-space-around align-items">查看订单详情</div>
							</div>
						</div>
					</div>
				</div>
				<div class="col-lg-2"></div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				payshowstatus: "4",
				payOkData: {},
			};
		},
		created() {
			if (window.localStorage.getItem('payOkData') != null) {
				this.payOkData = JSON.parse(window.localStorage.getItem('payOkData'));
			}
		},
		methods: {
			touser() {
				this.$router.push({
					path: "/user"
				});
			},
		},
	};
</script>

<style>
	@import url("../style/step.css");
</style>
